import ReactDOM from "react-dom";
import { DrawerProps } from "./drawer.interface";
import times from "../../../assets/images/sidebar/Times.svg";
import { zIndexs } from "../../../interfaces/environment";
import { useEffect, useState } from "react";
import NameDisplay from "../displayFaEn/showCorrectName/showCorrectName.index";

export default function Drawer({ status, onClose, closeButton = true, title, closeOnBlur, children, className, icon }: DrawerProps) {
    const [kill, setKill] = useState(false);
    const [drawerStatus, setDrawerStatus] = useState(false);

    useEffect(() => {
        window.addEventListener("popstate", () => {
            onClose();
        });
        return () => {
            window.removeEventListener("popstate", () => true);
        };
    }, []);

    useEffect(() => {
        if (!status) {
            setKill(true);
            setTimeout(() => {
                setDrawerStatus(false);
                setKill(false);
            }, 500);
        } else {
            setDrawerStatus(status);
        }
    }, [status]);

    return drawerStatus
        ? ReactDOM.createPortal(
              <div className={`fixed top-0 left-0 w-full h-full`} style={{ zIndex: zIndexs.otherModals }}>
                  <div
                      className={`fixed top-0 left-0 bg-black bg-opacity-70 w-full h-full animate__animated animate__faster ${kill ? "animate__fadeOut" : "animate__fadeIn"}`}
                      onClick={() => {
                          if (closeOnBlur) onClose();
                      }}
                  />
                  <div className="flex h-full">
                      <div
                          className={`${className} bg-white flex animate__animated animate__faster max-h-full overflow-hidden w-full sm:w-[400px] rounded-tl-[40px] rounded-bl-[40px]
                        ${kill ? `animate__slideOutRight` : `animate__slideInRight`}
                    `}
                          style={{ zIndex: zIndexs.otherModals + 1 }}
                      >
                          <div className="flex flex-col flex-1 w-full overflow-hidden">
                              {(closeButton || title) && (
                                  <div className="flex items-center gap-4 justify-between p-4">
                                      <div className="flex items-center gap-2 truncate">
                                          {icon && <img src={icon} alt="icon" />}
                                          {title && (
                                              <h3 className="truncate text-[18px] font-[700] text-secondary-800">
                                                  <NameDisplay TextInput={title} />
                                              </h3>
                                          )}
                                      </div>
                                      {closeButton && <img src={times} alt="times" onClick={onClose} className="cursor-pointer" />}
                                  </div>
                              )}
                              <div className="overflow-auto no-scrollbar flex flex-col flex-1">{children}</div>
                          </div>
                      </div>
                  </div>
              </div>,
              document.getElementById("drawer-react-root")!
          )
        : null;
}
